module.exports = __webpack_public_path__ + "static/media/Story-PS-Student Personas.2216dfdb.png";